const createMuiSkeletonStyles = () => ({
    styleOverrides: {
        root: {
            transform: 'scale(1, 0.8)',
        },
    },
});

export default createMuiSkeletonStyles;
